import { z } from 'zod';

/**
 * Wire schema for the profile taste endpoint (`GET /api/users/:id/taste`).
 * Matches the gateway's snake_case response contract.
 */
export const tasteResponseWireSchema = z.object({
  distribution: z.object({
    not_for_me: z.number().int().min(0),
    okay: z.number().int().min(0),
    try_it: z.number().int().min(0),
    must_try: z.number().int().min(0),
  }),
  total: z.number().int().min(0),
});

export type TasteResponseWire = z.infer<typeof tasteResponseWireSchema>;
